import { useQuery } from '@tanstack/react-query';
import { getUsersByOrg } from '../services/users';

export const GetOrganizationUsers = (pageNumber = 1, pageSize = 10) => {
  return useQuery({
    queryKey: ['organizationUsers', pageNumber, pageSize],
    queryFn: () => getUsersByOrg(pageNumber, pageSize),
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, //
  });
};
